import React from 'react';

interface CodeIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const CodeIcon: React.FC<CodeIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  className,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" fill={fill} />
  </svg>
);

export default CodeIcon;
